import React from "react";
import { Input } from "../../../../../../../../../../../../components";
import { FORM_KEYS } from "../../../../../../../../../../constants";
/**
 * @desc Input price for product details form.
 */
export const InputProductPrice = ({ product }) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: `${product.sku}-form-product-price-error`,
  };

  const inputProps = {
    type: "number",
    id: `${product.sku}-input-product-price`,
    className: "form-control",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "PRICE",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.PRODUCT_PRICE,
  };

  return <Input {...parentProps} />;
};
